var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14355 12.3937L14.2686 3.76875L20.2498 3.75L20.2311 9.73125L11.6061 16.8563",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.625L15 9",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69706 18.5155L4.89393 21.3187C4.75333 21.4589 4.56284 21.5377 4.36424 21.5377C4.16565 21.5377 3.97516 21.4589 3.83456 21.3187L2.68143 20.1655C2.54117 20.0249 2.4624 19.8345 2.4624 19.6359C2.4624 19.4373 2.54117 19.2468 2.68143 19.1062L5.48456 16.303C5.55542 16.2333 5.61169 16.1501 5.65011 16.0583C5.68852 15.9666 5.7083 15.8681 5.7083 15.7687C5.7083 15.6692 5.68852 15.5707 5.65011 15.479C5.61169 15.3873 5.55542 15.3041 5.48456 15.2343L3.53456 13.2843C3.46369 13.2145 3.40742 13.1313 3.369 13.0396C3.33059 12.9478 3.31081 12.8494 3.31081 12.7499C3.31081 12.6505 3.33059 12.552 3.369 12.4603C3.40742 12.3685 3.46369 12.2853 3.53456 12.2155L4.71581 11.0343C4.78559 10.9634 4.86878 10.9072 4.96052 10.8687C5.05226 10.8303 5.15072 10.8105 5.25018 10.8105C5.34964 10.8105 5.4481 10.8303 5.53984 10.8687C5.63158 10.9072 5.71477 10.9634 5.78456 11.0343L12.9658 18.2155C13.0367 18.2853 13.0929 18.3685 13.1314 18.4603C13.1698 18.552 13.1896 18.6505 13.1896 18.7499C13.1896 18.8494 13.1698 18.9478 13.1314 19.0396C13.0929 19.1313 13.0367 19.2145 12.9658 19.2843L11.7846 20.4655C11.7148 20.5364 11.6316 20.5927 11.5398 20.6311C11.4481 20.6695 11.3496 20.6893 11.2502 20.6893C11.1507 20.6893 11.0523 20.6695 10.9605 20.6311C10.8688 20.5927 10.7856 20.5364 10.7158 20.4655L8.76581 18.5155C8.69602 18.4447 8.61283 18.3884 8.52109 18.35C8.42935 18.3116 8.33089 18.2918 8.23143 18.2918C8.13197 18.2918 8.03351 18.3116 7.94177 18.35C7.85003 18.3884 7.76684 18.4447 7.69706 18.5155Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSword);
export default __webpack_public_path__ + "static/media/Sword.710477a54062a3f0535e679404c35248.svg";
export { ForwardRef as ReactComponent };